// Example: https://dev.to/kirteshbansal/bouncing-dots-loader-in-react-4jng
import React from "react";

import "./style.css";

export const BouncingDotsLoader = () => {
  return (
    <div className="bouncing-loader">
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};
